export function CloseSVG() {
  return (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.63615 0.79501L1.09131 9.33984" stroke="white" strokeWidth="1" />
      <path d="M9.63615 9.08194L1.09131 0.537109" stroke="white" strokeWidth="1" />
    </svg>
  )
}
